<div
    class="dialog-container sai-dialog-shell table-history"
    [dir]="lang === 'en' ? 'ltr' : 'rtl'"
>
    <ng-container *transloco="let t">
        <app-sai-dialog-header (closed)="close()">
            <mat-icon saiDialogHeaderIcon [svgIcon]="'heroicons_outline:clock'"></mat-icon>
            <ng-container saiDialogHeaderTitle>{{ t('Change history') }}</ng-container>
            <div class="header-subtitle" saiDialogHeaderSubtitle>
                {{ t('Table') }}: <strong>{{ data.displayName }}</strong>
            </div>
        </app-sai-dialog-header>

        <div class="relative">
            <mat-progress-bar *ngIf="loading || reverting" mode="indeterminate"></mat-progress-bar>
        </div>

        <div class="table-history__body px-6 py-4 overflow-y-auto">
            <div *ngIf="errorMessage" class="flex flex-col items-center gap-3 py-8" role="alert">
                <mat-icon class="text-warn icon-size-8" [svgIcon]="'heroicons_outline:exclamation-triangle'"></mat-icon>
                <span class="text-center">{{ t(errorMessage) }}</span>
                <button mat-stroked-button type="button" (click)="load()">{{ t('Retry') }}</button>
            </div>

            <ng-container *ngIf="!loading && !errorMessage && page && !page.entries.length">
                <app-no-data-found class="w-full" />
                <p class="text-center text-secondary mt-2">
                    {{ t('No changes have been recorded for this table yet.') }}
                </p>
            </ng-container>

            <ul *ngIf="page?.entries?.length" class="flex flex-col gap-3">
                <li
                    *ngFor="let e of page.entries"
                    class="sai-card p-4"
                    [class.table-history__item--reverted]="e.revertedById"
                >
                    <div class="flex flex-wrap items-center gap-2">
                        <span class="text-lg font-semibold">{{ t(label(e)) }}</span>
                        <span *ngIf="rowLabel(e)" class="text-secondary text-sm">{{ t('Row') }}: {{ rowLabel(e) }}</span>
                        <span *ngIf="e.revertedById" class="sai-badge">{{ t('Reverted') }}</span>
                        <span *ngIf="isRevertEntry(e) && e.revertOfId" class="text-secondary text-sm">
                            {{ t('Reverts change') }} {{ e.revertOfId }}
                        </span>
                    </div>
                    <div class="mt-1 flex flex-wrap gap-x-6 gap-y-1 text-sm text-secondary">
                        <span>{{ t('When') }}: {{ e.createdAt | date: 'medium' }}</span>
                        <span>{{ t('Requested by') }}: {{ actorLabel(e) }}</span>
                        <span *ngIf="e.agent">{{ t('Agent') }}: {{ agentLabel(e) }}</span>
                    </div>

                    <table class="table-history__changes mt-3">
                        <thead>
                            <tr>
                                <th>{{ t('Column') }}</th>
                                <th>{{ t('Before') }}</th>
                                <th>{{ t('After') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let c of changes(e)">
                                <td>{{ c.column }}</td>
                                <td><span class="table-history__before" dir="auto">{{ c.before }}</span></td>
                                <td dir="auto">{{ c.after }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div *ngIf="canRevert && e.revertible" class="mt-3 flex flex-wrap gap-2">
                        <button
                            mat-flat-button
                            type="button"
                            class="bg-primary"
                            (click)="askRevert(e)"
                            [disabled]="reverting"
                        >
                            <mat-icon [svgIcon]="'heroicons_outline:arrow-uturn-left'"></mat-icon>
                            <span class="ms-1">{{ t('Revert') }}</span>
                        </button>
                    </div>
                </li>
            </ul>
        </div>

        <div
            *ngIf="confirming"
            class="px-6 py-4 border-t"
            role="alertdialog"
            aria-live="polite"
        >
            <p class="font-medium">{{ t('Revert this change?') }}</p>
            <p class="text-sm text-secondary mt-1">
                {{
                    confirming.operation === 'insert'
                        ? t('The row that was added will be removed.')
                        : t('Only the fields this change touched will be restored to their previous values.')
                }}
                {{ t('The original entry is kept, and the revert is recorded in the history.') }}
            </p>
            <div class="mt-3 flex gap-2 justify-end">
                <button mat-stroked-button type="button" (click)="cancelRevert()" [disabled]="reverting">
                    {{ t('Cancel') }}
                </button>
                <button
                    mat-flat-button
                    type="button"
                    class="bg-primary"
                    (click)="confirmRevert()"
                    [disabled]="reverting"
                >
                    {{ reverting ? t('Reverting...') : t('Revert') }}
                </button>
            </div>
        </div>

        <div class="dialog-footer px-6 py-3 flex justify-end border-t">
            <button mat-stroked-button type="button" (click)="close()">{{ t('Close') }}</button>
        </div>
    </ng-container>
</div>
